module.exports = __webpack_public_path__ + "img/16_61.8ad6c97a.png";